import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

const CarTypeDropdown = ({ carType, carTypes, onCarTypeChange, t }) => {
  const [isOpen, setIsOpen] = useState(false);
  const rootRef = useRef(null);
  const outsideHandlerRef = useRef(null);
  const selectedCarType = carTypes.find(item => item.value === carType) || carTypes[0];

  useEffect(() => {
    if (!isOpen) return undefined;

    // откладываем подписку, чтобы клик открытия не закрыл список сразу
    const timeoutId = setTimeout(() => {
      const handleDocumentClick = event => {
        if (rootRef.current && !rootRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
      outsideHandlerRef.current = handleDocumentClick;
      document.addEventListener("click", handleDocumentClick);
    }, 0);

    return () => {
      clearTimeout(timeoutId);
      if (outsideHandlerRef.current) {
        document.removeEventListener("click", outsideHandlerRef.current);
        outsideHandlerRef.current = null;
      }
    };
  }, [isOpen]);

  const handleSelect = (value, disabled) => {
    if (disabled) return;
    onCarTypeChange(value);
    setIsOpen(false);
  };

  return (
    <div className="glz-dropdown-toggle averageRates__carType" ref={rootRef}>
      <button
        type="button"
        className="glz-trigger glz-link glz-is-medium glz-is-primary"
        onClick={() => setIsOpen(open => !open)}
        aria-expanded={isOpen}
      >
        {t(selectedCarType.shortLabelKey, selectedCarType.value)}
        <span className="glz-after-icon">
          <svg
            width="10"
            height="5"
            viewBox="0 0 10 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            style={isOpen ? { transform: "rotate(180deg)" } : undefined}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.251699 0.781501C-0.186662 0.34989 -0.0371629 0 0.581327 0L9.4143 0C10.0347 0 10.1911 0.341205 9.74392 0.781501L5.79153 4.67303C5.35317 5.10464 4.65127 5.11332 4.20409 4.67303"
              fill="#2277CC"
            />
          </svg>
        </span>
      </button>
      {isOpen && (
        <div className="glz-dropdown glz-is-bottom-right">
          <div className="glz-dropdown-list">
            {carTypes.map(item => {
              const isActive = item.value === carType;
              const className = [
                "glz-dropdown-list-item",
                isActive && "glz-dropdown-list-item-active",
                item.disabled && "glz-dropdown-list-item-disabled",
              ]
                .filter(Boolean)
                .join(" ");

              return (
                <button
                  key={item.value}
                  type="button"
                  className={className}
                  disabled={item.disabled}
                  onClick={() => handleSelect(item.value, item.disabled)}
                >
                  {t(item.labelKey, item.value)}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

CarTypeDropdown.propTypes = {
  carType: PropTypes.string.isRequired,
  carTypes: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      labelKey: PropTypes.string.isRequired,
      shortLabelKey: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
    }),
  ).isRequired,
  onCarTypeChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default CarTypeDropdown;
